import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUpData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
//import SnGrid from "@shared/components/Grid/SnGrid";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnTab from "@shared/components/SnTab";
import SnSearchBtn from "@shared/components/SnSearchBtn";
import { SnGridRef } from "@shared/components/GridV2/SnGridTypes";
import { showDialog } from "@widgets/CommonDialog";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_PUR_PTX_REG_001_POP_01 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const searchRef = useRef<any>(null);
    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
      grid2: React.createRef(),
      grid3: React.createRef(),
      grid4: React.createRef(),
    });
    //#endregion

    //#region Components useState
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);

    const [columns, setColums] = useState<any>({
      grid1: [],
      grid2: [],
      grid3: [],
      grid4: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
      grid2: [],
      grid3: [],
      grid4: [],
    });

    const [selectedTabPage, setTapPage] = useState<string>("1");
    const [amK, setAmK] = useState<number>(0);
    const [amVat, setAmVat] = useState<number>(0);
    const [am, setAm] = useState<number>(0);
    const [qt, setQt] = useState<number>(0);
    //#endregion

    const getGridCurrent = (key: string): SnGridRef => {
      const grid = gridRefs.current[key]?.current;
      if (!grid) {
        throw new Error(`Grid '${key}' is not mounted yet`);
      }
      return grid;
    };

    useImperativeHandle(ref, () => ({
      checkValidity: async () => {
        let isSame: boolean = false;
        let checkValidity = false;
        let selectedRowsH: any[] = [];
        switch (selectedTabPage) {
          case "1":
            selectedRowsH = getGridCurrent("grid1")?.getCheckedRows() || [];
            break;
          case "2":
            selectedRowsH = getGridCurrent("grid3")?.getCheckedRows() || [];
            break;
        }

        if (selectedRowsH && selectedRowsH.length > 0) {
          const cdCustValue = selectedRowsH[0].cd_cust; // 거래처

          isSame = selectedRowsH.every(
            (item: any) => item.cd_cust === cdCustValue
          );
        } else {
          checkValidity = true;
        }

        if (!isSame) {
          showDialog("alter", "거래처가 동일한 건만 적용 가능합니다.");
        } else {
          checkValidity = true;
        }
        return checkValidity;
      },

      getOkayData: () => {
        let result;
        switch (selectedTabPage) {
          case "1":
            result = [
              getGridCurrent("grid1")?.getCheckedRows() || [],
              getGridCurrent("grid2")?.getCheckedRows() || [],
            ];
            break;
          case "2":
            result = [
              getGridCurrent("grid3")?.getCheckedRows() || [],
              getGridCurrent("grid4")?.getCheckedRows() || [],
            ];
            break;
          default:
            result = [[], []];
        }
        return {
          rtnData: result,
        };
      },
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_PUR_PTX_REG_001_POP_01",
            {}
          );
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData); // 조회조건 항목 설정
          setFormData(mergedData); // 조회조건 초기값
          setColums({
            grid1: rtn.grid.grid1,
            grid2: rtn.grid.grid2,
            grid3: rtn.grid.grid3,
            grid4: rtn.grid.grid4,
          });
        } catch (error) {}
      };
      fetchform();
    }, [userInfo]);

    //#region Button Event
    const onSearch = () => {
      const fetchdatasource = async () => {
        try {
          const params = {
            id: "sn_pur_ptx_reg_001_pop_001_02",
            params: searchRef.current.getFormdata(),
          };

          getGridCurrent("grid1").resetUpdate();
          getGridCurrent("grid2").resetUpdate();
          getGridCurrent("grid3").resetUpdate();
          getGridCurrent("grid4").resetUpdate();

          const data: any = await fnGetDataSet(params);
          setDataSources({
            grid1: data[0] || [],
            grid2: data[1] || [],
            grid3: data[2] || [],
            grid4: data[3] || [],
          });
        } catch (error) {
          console.log(error);
        }
      };
      fetchdatasource();
    };
    //#endregion

    //#region Event Method
    const onTabChanged = (index: string) => {
      setTapPage(index);
    };
    const onCheckedRowChaged1 = (
      value: boolean,
      type: "row" | "header" = "row"
    ) => {
      if (type === "header") {
        getGridCurrent("grid2").setCheckedAll(value);
      } else {
        getGridCurrent("grid2").setCheckedAllWithFilter(value);
      }
      handleSelectionChange("grid2");
    };

    const onCheckedRowChaged2 = (value: boolean) => {
      const checkdRows = getGridCurrent("grid2").getCheckedFilteredRows();
      if (checkdRows.length > 0) {
        getGridCurrent("grid1").setCheckedFocusedRow(true, "noEvent");
      } else {
        getGridCurrent("grid1").setCheckedFocusedRow(false);
      }
      handleSelectionChange("grid2");
    };

    const onCheckedRowChaged3 = (
      value: boolean,
      type: "row" | "header" = "row"
    ) => {
      if (type === "header") {
        getGridCurrent("grid4").setCheckedAll(value);
      } else {
        getGridCurrent("grid4").setCheckedAllWithFilter(value);
      }
      handleSelectionChange("grid4");
    };

    const onCheckedRowChaged4 = (value: boolean) => {
      const checkdRows = getGridCurrent("grid4").getCheckedFilteredRows();
      if (checkdRows.length > 0) {
        getGridCurrent("grid3").setCheckedFocusedRow(true, "noEvent");
      } else {
        getGridCurrent("grid3").setCheckedFocusedRow(false, "noEvent");
      }
      handleSelectionChange("grid4");
    };

    const handleSelectionChange = (grid: string) => {
      if (!grid) return;

      const gridRef = getGridCurrent(grid);
      if (!gridRef) return;

      const selectedRows = gridRef.getCheckedRows();
      if (selectedRows.length === 0) {
        setAmK(0);
        setAmVat(0);
        setAm(0);
        setQt(0);
        return;
      }

      const totalAmk = selectedRows.reduce((acc: number, row: any) => {
        return row.fg_io === "1" ? acc + row.am_k : acc - row.am_k;
      }, 0);

      const totalAmvat = selectedRows.reduce((acc: number, row: any) => {
        return row.fg_io === "1" ? acc + row.am_vat : acc - row.am_vat;
      }, 0);

      const totalAm = selectedRows.reduce((acc: number, row: any) => {
        return row.fg_io === "1" ? acc + row.am : acc - row.am;
      }, 0);

      const totalQt = selectedRows.reduce((acc: number, row: any) => {
        return row.fg_io === "1" ? acc + row.qt : acc - row.qt;
      }, 0);

      setAmK(totalAmk);
      setAmVat(totalAmvat);
      setAm(totalAm);
      setQt(totalQt);
    };

    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
          events: {
            onCheckedRowChaged: onCheckedRowChaged1,
          },
        },
        grid2: {
          columns: columns.grid2,
          dataSource: dataSources.grid2,
          events: {
            onCheckedRowChaged: onCheckedRowChaged2,
          },
        },
        grid3: {
          columns: columns.grid3,
          dataSource: dataSources.grid3,
          events: {
            onCheckedRowChaged: onCheckedRowChaged3,
          },
        },
        grid4: {
          columns: columns.grid4,
          dataSource: dataSources.grid4,
          events: { onCheckedRowChaged: onCheckedRowChaged4 },
        },
      }),
      [columns, dataSources]
    );
    //#endregion

    return (
      <div className="h-full flex flex-col">
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>

        <div style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>
        <div className="flex-1 h-full min-h-0 space-y-1.5">
          <SnTab
            titles={["입고번호별", "거래처별"]}
            width={"100%"}
            onTabChanged={onTabChanged}
            body={[
              <div className="h-full flex flex-col gap-y-1.5">
                <SnGrid
                  ref={gridRefs.current["grid1"]}
                  columnConfig={grids.grid1.columns}
                  rowData={grids.grid1.dataSource}
                  etcProps={{
                    rowSelection: "multiple",
                    ischeckboxSelection: true,
                  }}
                  events={grids.grid1.events}
                  filter={{
                    refs: [gridRefs.current["grid2"]],
                    columns: ["no_io"],
                  }}
                />
                <SnGrid
                  ref={gridRefs.current["grid2"]}
                  columnConfig={grids.grid2.columns}
                  rowData={grids.grid2.dataSource}
                  etcProps={{
                    rowSelection: "multiple",
                    ischeckboxSelection: true,
                  }}
                  events={grids.grid2.events}
                />
              </div>,

              <div className="h-full flex flex-col gap-y-1.5">
                <SnGrid
                  ref={gridRefs.current["grid3"]}
                  columnConfig={grids.grid3.columns}
                  rowData={grids.grid3.dataSource}
                  etcProps={{
                    rowSelection: "multiple",
                    ischeckboxSelection: true,
                  }}
                  events={grids.grid3.events}
                  filter={{
                    refs: [gridRefs.current["grid4"]],
                    columns: ["cd_cust", "cd_exch", "fg_trns", "fg_money"],
                  }}
                />
                <SnGrid
                  ref={gridRefs.current["grid4"]}
                  columnConfig={grids.grid4.columns}
                  rowData={grids.grid4.dataSource}
                  etcProps={{
                    rowSelection: "multiple",
                    ischeckboxSelection: true,
                  }}
                  events={grids.grid4.events}
                />
              </div>,
            ]}
          />
        </div>
      </div>
    );
  }
);

export default SN_PUR_PTX_REG_001_POP_01;
